module.exports = __webpack_public_path__ + "img/gh-202-flpart6.prt.aa193d2d.jpg";